export default __webpack_public_path__ + "assets/icons/arrow-down.d3b70555.svg";